export default __webpack_public_path__ + "static/media/songImg.4690a8c2.jpg";